import { SET_SEARCH_CACHE, CLEAR_SEARCH_CACHE } from "./searchActions";

const initialState = {
  queryKey: null,
  listData: {},
  typeSearch: null,
  pageIndex: 1,
  count: 0
};

export default function searchReducer(state = initialState, action) {
  switch (action.type) {
    case SET_SEARCH_CACHE:
      return {
        ...state,
        ...action.payload
      };
    case CLEAR_SEARCH_CACHE:
      return initialState;
    default:
      return state;
  }
}
